"use strict";
/**
 * Global variables
 */
const debounce = require("lodash/debounce");
let prevScrollPos = window.scrollY;
const header = document.querySelector(".header-container");
const subNavItems = document.querySelectorAll(".sub-nav-item");
const navItems = document.querySelectorAll(".nav-item.dropdown");
const dropdownMenus = document.querySelectorAll(".nav-item.dropdown");

/**
 * Hides the header on scroll
 * @function
 * @returns {void}
 */
const hideHeaderOnScroll = () => {
    if (document.querySelector(".multilevel-dropdown").classList.contains("in")) {
        return;
    }

    const currentScrollPos = window.scrollY;

    if (prevScrollPos > currentScrollPos) {
        header.style.top = "-1px";
    } else {
        collapseMenus();
        header.style.top = `-${header.offsetHeight}px`;
    }

    prevScrollPos = currentScrollPos;
};

/**
 * Checks header state on page load
 * @function
 * @returns {void}
 */
const checkHeaderState = () => {
    if (window.scrollY === 0) {
        header.style.top = "-1px";
    }
};

/**
 * Collapse dropdown menus on scroll
 * @function
 * @returns {void}
 */
const collapseMenus = () => {
    dropdownMenus.forEach((menu) => {
        if (menu.classList.contains("show")) {
            menu.classList.remove("show");
            menu.querySelector(".dropdown-menu").classList.remove("show");
        }
    });
};

/**
 * Handles the click event for a navigation item
 * @param {Event} event - the click event
 * @param {string} linkSelector - the selector for the link element
 * @returns {void}
 */
const handleNavItemClick = (event, linkSelector) => {
    const target = event.target;
    const currentTarget = event.currentTarget;

    if (
        (target === currentTarget || target.parentNode === currentTarget) &&
        currentTarget.querySelector(linkSelector) &&
        target.id !== currentTarget.querySelector(linkSelector).id
    ) {
        currentTarget.querySelector(linkSelector).click();
    }
};

/**
 * Binds events for the header element
 * @returns {void}
 */
const bindEvents = () => {
    if (header) {
        checkHeaderState();
        window.addEventListener("scroll", debounce(hideHeaderOnScroll, 50), {passive: true});
    }

    navItems.forEach((navItem) => {
        navItem.addEventListener("click", (e) => handleNavItemClick(e, ".nav-link"));
    });

    subNavItems.forEach((subNavItem) => {
        subNavItem.addEventListener("click", (e) => handleNavItemClick(e, ".dropdown-link"));
    });
};

module.exports = {
    bindEvents,
};
